import { useNavigate } from 'react-router-dom';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import AlertBox from '../atoms/AlertBox';
import Button from '../atoms/Button';
import Badge from '../atoms/Badge';
import Title from '../atoms/Title';

function ProfileCompleteness({ required, value }) {
    const requiredFieldsLabels = {
        country: i18next.t('country'),
        certification: i18next.t('certifications'),
        education: i18next.t('education'),
        job: i18next.t('work-experience'),
        languages: i18next.t('languages'),
        salaries: i18next.t('salary'),
    };

    const navigate = useNavigate();
    const incompleteFields = Object.entries(required || {})
        .filter(([_, isComplete]) => !isComplete)
        .map(([field]) => requiredFieldsLabels[field]);

    if (value === 100) {
        return null;
    }

    return (
        <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50 w-full max-w-xl pointer-events-none">
            <div className="pointer-events-auto">
                <AlertBox color="orange" className="max-w-2xl mx-auto my-4 bg-white shadow-lg">
                    <div className="flex flex-col gap-2 w-full">
                        <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
                            <span className="font-semibold">
                                <Title level={5} size="md" className="!mb-0">
                                    {i18next.t('profile-completeness-title')}
                                </Title>
                            </span>
                            <span className="ml-2">
                                <Badge size="lg" color="orange">
                                    {value}%
                                </Badge>
                            </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded h-2 overflow-hidden my-2">
                            <div
                                className="bg-smorange h-2 transition-all duration-300"
                                style={{ width: `${value}%` }}
                            />
                        </div>
                        <div>
                            <span className="text-sm text-black">
                                {i18next.t('profile-completeness-missing-fields')}
                            </span>
                            <ul className="list-disc list-inside mt-1 pl-4">
                                {incompleteFields.map((field) => (
                                    <li key={field} className="text-sm text-smred-darker font-medium">
                                        {field}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <Button
                            size="small"
                            color="orange"
                            onClick={() => navigate('/profile')}
                            className="mt-2 sm:mt-0"
                        >
                            {i18next.t('profile-completeness-button')}
                        </Button>
                    </div>
                </AlertBox>
            </div>
        </div>
    );
}

ProfileCompleteness.propTypes = {
    required: PropTypes.shape({
        country: PropTypes.bool,
        certification: PropTypes.bool,
        education: PropTypes.bool,
        job: PropTypes.bool,
        languages: PropTypes.bool,
        salaries: PropTypes.bool,
    }).isRequired,
    value: PropTypes.number.isRequired,
};

export default ProfileCompleteness;
